import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useIdleTimeout from "./useIdleTimeout";
import IdleOverLay from "./IdleOverlay";
import { logOut } from "../actions/loginAction";
import { registeredLogout } from "../actions/registeredUserAction";

const ActiveIdleManager = ({ isRegistered, idleMinutes }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showIdleOverlay, setShowIdleOverlay] = useState(false);

  useEffect(() => {
    try {
      sessionStorage.setItem("globalIdleActive", "true");
    } catch (e) {}
    return () => {
      try {
        sessionStorage.removeItem("globalIdleActive");
      } catch (e) {}
    };
  }, []);

  const showIdlePrompt = () => setShowIdleOverlay(true);

  const handleLogout = () => {
    setShowIdleOverlay(false);
    if (isRegistered) {
      dispatch(registeredLogout());
      try { sessionStorage.clear(); } catch (e) {}
      history.replace("/registeredlogin");
    } else {
      dispatch(logOut());
      try { localStorage.clear(); } catch (e) {}
      history.replace("/");
    }
  };

  const { idleTimer } = useIdleTimeout({
    promptBeforeIdle: showIdlePrompt,
    idleTime: idleMinutes,
    doWhenIdle: handleLogout,
  });

  const handleStay = () => {
    setShowIdleOverlay(false);
    if (idleTimer && typeof idleTimer.reset === "function") {
      idleTimer.reset();
    }
    try { sessionStorage.setItem("lastActivity", String(Date.now())); } catch (e) {}
  };

  return (
    <IdleOverLay
      show={showIdleOverlay}
      handleStay={handleStay}
      handleLogout={handleLogout}
    />
  );
};

const GlobalIdleManager = () => {
  const loginDetails = useSelector((state) => state.loginDetails);
  const regDetails = useSelector((state) => state.registeredUserDetails);

  const isRegistered =
    Boolean(regDetails && (regDetails.loginSuccess || regDetails.userData)) &&
    Boolean(regDetails?.userData?.id);
  const isGuest =
    Boolean(loginDetails && loginDetails.userInfo) &&
    Boolean(loginDetails?.userInfo?.id);

  const isLoggedIn = isRegistered || isGuest;

  const raw = process.env.REACT_APP_USER_IDLE_TIMEOUT_MINUTES;
  const parsed = Number.isFinite(Number(raw)) ? parseInt(raw, 10) : NaN;
  if (Number.isNaN(parsed) || parsed <= 0) {
    return null;
  }

  return isLoggedIn ? (
    <ActiveIdleManager isRegistered={isRegistered} idleMinutes={parsed} />
  ) : null;
};

export default GlobalIdleManager;
